module.exports = __webpack_public_path__ + "img/trucking.f9739530.png";